import React, { useMemo, useState, useCallback, useEffect } from "react";
import SearchComponent from "../../components/Search";
import PaginationComponent from "../../components/Pagination/Pagination";
import { debounce } from "lodash";
import { useSelector, useDispatch } from "react-redux";
import { fetchGroups } from "../../redux/Loans/loanActions";

const LoanGroupsTable = () => {
  const [searchValue, setSearchValue] = useState("");
  const { loading, groups } = useSelector((state) => state.loan);
  const dispatch = useDispatch();

  const [currentPage, setCurrentPage] = useState(1);

  const onPageChange = (val) => {
    const { page } = val;
    setCurrentPage(page);
  };

  // handle search
  const handleSearch = useMemo(
    () =>
      debounce((val) => {
        //  api to dispatch and make the actions for search
        // dispatch(
        //     searchCallRequests({
        //       val: val,
        //       status: 'all',
        //     }),
        //   )
        console.log(val);
      }, 750),
    []
  );

  const handleChange = useCallback(
    (e) => {
      let val = e.target.value;
      setSearchValue(val);
      handleSearch(val);
    },
    [handleSearch]
  );

  useEffect(() => {
    dispatch(fetchGroups());
  }, [dispatch]);

  return (
    <>
      <div className="mt-4 bg-white rounded-[8px]">
        <div className="p-4">
          {/* search */}
          <div className="mt-4">
            <SearchComponent
              placeholder="Search..."
              searchValue={searchValue}
              handleChange={handleChange}
            />
          </div>
        </div>

        {/* tables */}
        <div className="overflow-x-auto relative">
          <table className="w-full text-left">
            <thead className="text-primary text-sm border-b-[#F7F7F7] border-b-2">
              <tr>
                <th scope="col" className="px-4 py-4 font-semibold ">
                  Loan Officer
                </th>

                <th scope="col" className="px-4 py-4 font-semibold">
                  Group Name
                </th>
                <th scope="col" className="px-4 py-4 font-semibold">
                  State
                </th>
                <th scope="col" className="px-4 py-4 font-semibold">
                  LGA
                </th>
                <th scope="col" className="px-4 py-4 font-semibold">
                  Members
                </th>
              </tr>
            </thead>
            {!loading && (
              <tbody>
                {groups.length > 0
                  ? groups.map((item) => (
                      <tr
                        key={item.id}
                        className="bg-white text-sm cursor-pointer hover:bg-[#EDF7EE]"
                      >
                        <th
                          scope="row"
                          className="py-4 px-4 font-normal text-[#5C715E] whitespace-nowrap "
                        >
                          {item.loan_officer.officer_name === ""
                            ? "N/A"
                            : item.loan_officer.officer_name}
                        </th>

                        <td className="py-4 px-4 text-[#5C715E]">
                          {item.name}
                        </td>
                        <td className="py-4 px-4 text-[#5C715E]">
                          {item.state.name}
                        </td>
                        <td className="py-4 px-4 text-[#5C715E]">
                          {item.lga.name}
                        </td>
                        <td className="py-4 px-4">{item.members}</td>
                      </tr>
                    ))
                  : ""}
              </tbody>
            )}
          </table>

          {loading && (
            <div className="animate-pulse w-full mt-4 px-4 mb-4">
              <div className="h-10 bg-gray-200 rounded-lg  w-full mb-2"></div>
              <div className="h-10 bg-gray-200 rounded-lg  w-full mb-2"></div>
              <div className="h-10 bg-gray-200 rounded-lg  w-full mb-2"></div>
              <div className="h-10 bg-gray-200 rounded-lg  w-full mb-2"></div>
              <div className="h-10 bg-gray-200 rounded-lg  w-full mb-2"></div>
              <div className="h-10 bg-gray-200 rounded-lg  w-full"></div>
            </div>
          )}
        </div>
      </div>
      <div className="mt-1">
        <PaginationComponent
          page={currentPage}
          onPageChange={(page) => onPageChange({ page })}
          pageSize={10}
          totalItems={12}
        />
      </div>
    </>
  );
};

export default LoanGroupsTable;
